<template>
  <div id="player" v-if="visible">
    <div class="artwork">
      <img v-if="album.thumbnail" :src="album.thumbnail" />
    </div>
    <div class="titles">
      <p class="title">{{ album.title }}</p>
      <p class="artist">{{ album.artist.name }}</p>
      <p v-if="context" class="list">in album list:
        <router-link :to="{ name: 'ListView', params: { id: context.id }}">{{ context.title }}</router-link>
      </p>
    </div>
    <div class="controls">
      <button @click="togglePlayer()">{{ isPlaying ? "Pause" : "Play" }}</button>
    </div>
    <div class="device">
      <p>{{device.name}}</p>
    </div>
  </div>
</template>

<script>
import Spotify from '@/services/Spotify'
export default {
  name: 'Player',
  components: {
  },
  data () {
    return {
      visible: false,
      context: false,
      album: {artist: {}},
      device: {name: ''},
      isPlaying: false,
      trackCount: 0
    }
  },
  mounted () {
    console.log('Player mounted')
  },
  methods: {
    reveal () {
      this.visible = true
    },
    destroy () {
      Spotify.destroy()
    },
    initPlayer (user) {
      console.log('Player.initPlayer', user)
      Spotify.init(user.spotify_access_token, this)
    },
    isCurrentAlbum (album) {
      return this.lpAlbum && album.id === this.lpAlbum.id
    },
    playAlbum (album, list) {
      console.log('Player.playAlbum', album, this.album)
      this.reveal()
      if (this.isCurrentAlbum(album)) {
        console.log('toggle currently playing album', album.id, this.lpAlbum.id)
        this.togglePlayer()
        return
      }
      this.context = list
      Spotify.playAlbum(album.spotify_id)
        .then(() => {
          this.lpAlbum = album
        })
    },
    skipTrack () {
      Spotify.skipTrack()
    },
    togglePlayer () {
      Spotify.togglePlayer()
    },
    onStateChanged (state) {
      this.isPlaying = !state.paused

      this.reveal()

      if ('spotify:album:' + this.album.spotify_id === state.context.uri) {
        console.log("album hasn't changed")
      } else {
        // if user is playing something completely different
        // from a remote control device
        // fetch metadata direct from API
        // if it's not an album - refuse to display?

        let track = state.track_window.current_track
        this.album = {
          title: track.album.name,
          artist: { name: track.artists[0].name },
          thumbnail: track.album.images[1].url,
          spotify_uri: track.album.uri
        }

        if (state.device) {
          this.device = state.device
        }

        // this.updateNowPlaying()
      }

      if (this.context) {
        var isInContext = false
        // check if the now playing album is in this list
        let currentAlbum = this.album
        this.context.entries.forEach(function (e) {
          let thisOne = 'spotify:album:' + e.album.spotify_id
          let thatOne = currentAlbum.spotify_uri
          if (thisOne === thatOne) {
            isInContext = true
          }
        })

        if (!isInContext) {
          this.context = false
        }
      }
    },
    updateNowPlaying () {
      Spotify.getNowPlaying()
        .then((resp) => {
          if (resp.status !== 200) {
            return
          }

          let data = resp.data

          this.isPlaying = data.is_playing

          let sAlbum = data.item.album
          this.album = {
            title: sAlbum.name,
            artist: { name: sAlbum.artists[0].name },
            thumbnail: sAlbum.images[1].url,
            spotify_id: sAlbum.id
          }
          this.device = data.device

          if (data.context.type !== 'album') {
            console.log('NOT AN ALBUM! Awkward...')
          }
        })
    }
  }
}
</script>

<style>
#app {
  padding-bottom: 150px;
}

#player {
  display: flex;
  position: fixed;
  bottom: 0;
  height: 80px;
  left: 0;
  right: 0;
  background-color: rgba(200,200,200,0.9);
  align-items: center;
}

#player .artwork {
  background: gray;
  margin-left: 10px;
}

#player .artwork,
#player .artwork img {
  width: 60px;
  height: 60px;
}
#player .titles {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  flex-grow: 1;
}
#player .titles p {
  color: #111;
  margin: 5px;
}
#player .titles .title {
  font-size: 1.1em
}
#player .titles .artist {
  font-size: 0.9em
}
#player .titles .list {
  font-size: 0.7em
}
#player .controls {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Player.vue